export default __webpack_public_path__ + "static/double_door_b.0fd10342ea4557985d1ba0caec8c8575.png";